module.exports = __webpack_public_path__ + "static/pawel-lg-e637ea4c4cf314f44019ebc6ef651b03.jpg";